import { TOTAL_IMAGES } from '../constants';

// Helper function to calculate circular distance
export const getCircularDistance = (from, to, totalImages = TOTAL_IMAGES) => {
  const directDistance = Math.abs(from - to);
  const wrapAroundDistance = totalImages - directDistance;
  return Math.min(directDistance, wrapAroundDistance);
};
